"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HcfThemeContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _CampaignHolder = require("@PetSureAustralia/petsure-react-ui-library/distLib/components/UIElements/Campaigns/CampaignHolder");
var _defaultBrandContext = require("../../defaults/defaultBrandContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var HcfThemeContext = exports.HcfThemeContext = _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
  brand: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.brand), {}, {
    key: 'hcf',
    products: 'hcf',
    title: 'HCF',
    fullName: 'The Hospitals Contribution Fund of Australia',
    shortName: 'HCF',
    logos: [{
      key: 'hcfLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/HCF/HCF_logo.png',
      redirectUrl: 'http://www.hcf.com.au/',
      target: '_blank',
      imageTitle: 'Get a pet insurance quote',
      imageTitleDescription: 'Provided by PetSure - Australia\'s leading Pet Insurance provider'
    }],
    partner: 'HCF',
    broker: 'HCF',
    styleSheet: 'hcf',
    partnerPrefix: 'HC',
    marketingPartner: 'The Hospitals Contribution Fund of Australia'
  }),
  layout: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1800630681",
        className: "contactLink"
      }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "phone"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "phoneText"
      }, "1800 630 681")), /*#__PURE__*/_react["default"].createElement("strong", {
        className: "contactSchedule"
      }, "Monday \u2013 Friday, 8:00am \u2013 8:00pm AET"), /*#__PURE__*/_react["default"].createElement("strong", {
        className: "m-contactSchedule"
      }, "Call us"))
    }),
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement(_CampaignHolder.CampaignHolder, {
        key: "HFCCampaign1",
        customCssClass: "HCFCampaign1",
        campaignImageDescription: "Mozo award",
        campaignBaseUrl: "",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/HCF/Tile_mozo_award.png",
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_CampaignHolder.CampaignHolder, {
        key: "HFCCampaign2",
        customCssClass: "HFCCampaign2",
        campaignImageDescription: "myPetPass logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/MyPetPass_QT_tile_464x400.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_CampaignHolder.CampaignHolder, {
        key: "HFCCampaign3",
        customCssClass: "HCFCampaign2",
        campaignImageDescription: "GapOnly ready Pet Insurance",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
        },
        __type: "CampaignHolder"
      })]
    },
    footer: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.footer), {}, {
      footerSections: null,
      socialLinks: null,
      copyright: null
    })
  }),
  preSubmitStatement: /*#__PURE__*/_react["default"].createElement("div", {
    className: "preSubmitStatement secondaryText"
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Privacy Collection Notice"), /*#__PURE__*/_react["default"].createElement("br", null), "PetSure (Australia) Pty Ltd (", /*#__PURE__*/_react["default"].createElement("strong", null, "PetSure"), ") collects the personal information that you provide throughout this process to provide you with a quote for HCF Pet Insurance. If you do not provide this information, PetSure will be unable to provide you with a quote. If you choose to proceed to obtain pet insurance, it will also be used to administer your application and the continued use of your policy. PetSure may disclose your information to third parties, including HCF (as the distributor of HCF Pet Insurance), as well as other third parties in connection with providing a quote and, where relevant, HCF Pet Insurance and other services PetSure provides. Information about how PetSure manages personal information is contained in the PetSure ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://petsure.com.au/privacy-policy/",
    rel: "noreferrer",
    target: "_blank"
  }, "Privacy Policy"), ". Information about how HCF manages personal information is contained in the HCF ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.hcf.com.au/about-us/about-HCF/governance-and-structure/policies/privacy-policy",
    rel: "noreferrer",
    target: "_blank"
  }, "Privacy Policy"), "."))
});
var _default = exports["default"] = {
  HcfThemeContext: HcfThemeContext
};